import {IMAGE_HOST} from '../config/config'

export const getNumberWithOrdinalWithSuperscript = (n) => {
  var s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return (
    <span>
      {n}
      <sup>{s[(v - 20) % 10] || s[v] || s[0]}</sup>
    </span>
  );
};


export const slugify = (str) => {
  return str
    .toString()                           // Cast to string (optional)
    .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
    .toLowerCase()                  // Convert the string to lowercase letters
    .trim()                                  // Remove whitespace from both sides of a string (optional)
    .replace(/\s+/g, '-')            // Replace spaces with -
    .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
    .replace(/\-\-+/g, '-');        // Replace multiple - with single -
}

export const formatNumberWithDot = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const groupBy = prop => data => {
  return data.reduce((dict, item) => {
    const { [prop]: _, ...rest } = item;
    dict[item[prop]] = [...(dict[item[prop]] || []), rest];
    return dict;
  }, {});
};

export const imageLink = (name) =>{
  const imageUrl = './images/' + slugify(name) + '.jpg';
  return imageUrl;
}

export const flag = (name) =>{
  const imageUrl = IMAGE_HOST + '/themes/hgo/public/assets/img/flags/' + slugify(name) + '.png';
  return imageUrl;
}

export const passport = (name) =>{
  const imageUrl = IMAGE_HOST + '/themes/hgo/public/assets/img/passports/' + slugify(name).toUpperCase() + '.png';
  return imageUrl;
}

export const emptyDeep = (mixedVar, emptyValues = [undefined, null, '']) =>{
  let i, len
  for (i = 0, len = emptyValues.length; i < len; i++) {
      if (mixedVar === emptyValues[i]) {
          return true
      }
  }
  if (typeof mixedVar === 'object') {
      for (const item of Object.values(mixedVar)) {
          if (!emptyDeep(item, emptyValues)) {
              return false
          }
      }
      return true
  }
  return false
}

export const getLonAndLat = (countryCode, features) =>{
  let dataset = [];
  for(let i = 0; i <= features.length; i++){

    if(features[i] && features[i].properties.ISO3){
      let name = features[i].properties.ISO3;
      let longitude = features[i].properties.LON;
      let latitude = features[i].properties.LAT;
      let country = features[i].properties.NAME

      dataset[name] = {
        country: country,
        longitude: longitude,
        latitude: latitude
      }
    }
  }

  // console.log(dataset);

  return dataset[countryCode];
} 

export function calculatePortfolioOverview(portfolioData, country) {
  // console.log(country);
  let response = {};
  // const freeVisaCountries = calculateFreeVisaCountries([country]);
  // find the overview data for a country by its iso code
  const found = portfolioData.find(row => row.iso_code.toUpperCase() === country.iso_code.toUpperCase());
  if (found) {
      const overall = found.business_opportunity + found.climate_resilience + found.economic_mobility + found.education + found.lifestyle + found.private_healthcare + found.safety_security;
      const minimumInvestmentUSD = (country.type === false) ? 0 : found.minimum_investment[country.type]?.usd || 0;
      const minimumInvestmentEUR = (country.type === false) ? 0 : found.minimum_investment[country.type]?.eur || 0;
      response = {
          iso_code: found.iso_code,
          country: found.country,
          overall: overall,
          businessOpportunity: found.business_opportunity,
          climateResilience: found.climate_resilience,
          economicFreedom: found.economic_freedom,
          economicMobility: found.economic_mobility,
          education: found.education,
          lifestyle: found.lifestyle,
          privateHealthcare: found.private_healthcare,
          safetyAndSecurity: found.safety_security,
          minimumInvestmentUSD: minimumInvestmentUSD,
          minimumInvestmentEUR: minimumInvestmentEUR,
          // freeVisaCountries: freeVisaCountries,
          // freeVisaCountriesCount: freeVisaCountries.length
      }
  }
  return response;
}

export function calculateSingleFreeVisaCountries(passportData, country) {

  const found = passportData.find(row => row.iso_code.toUpperCase() === country.iso_code.toUpperCase());

  return country.type === 'rpi' ? found.rpi_free_visa_countries.length : found.hpi_free_visa_countries.length;
}

export function formatPortfolioResult(results){
  const responses = {
    businessOpportunity: results.portfolio.business_opportunity,
    climateResilience: results.portfolio.climate_resilience_score,
    economicFreedom: results.portfolio.economic_freedom,
    economicMobility: results.portfolio.economic_mobility,
    education: results.portfolio.premium_education,
    lifestyle: results.portfolio.quality_of_life_result,
    privateHealthcare: results.portfolio.private_healthcare_result,
    safetyAndSecurity: results.portfolio.safety_security_result,
    businessOpportunityImprovement: results.diff_percent.business_opportunity,
    climateResilienceImprovement: results.diff_percent.climate_resilience_score,
    economicFreedomImprovement: results.diff_percent.economic_freedom,
    economicMobilityImprovement: results.diff_percent.economic_mobility,
    educationImprovement: results.diff_percent.premium_education,
    lifestyleImprovement: results.diff_percent.quality_of_life_result,
    privateHealthcareImprovement: results.diff_percent.private_healthcare_result,
    safetyAndSecurityImprovement: results.diff_percent.safety_security_result,
    passportOverall: results.passport.overall_score,
    overall:results.portfolio.overall_score,
    freeVisaCount: results.visa_free_count,
    freeVisaCountries: results.visa_free,
    minimumInvestmentUSD: results.minimum_investments.total.usd,
    minimumInvestmentEUR: results.minimum_investments.total.eur,
  }
  return responses;
}